import { render, staticRenderFns } from "./children-list.vue?vue&type=template&id=37ab7897"
import script from "./children-list.vue?vue&type=script&lang=js"
export * from "./children-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports